(function () {
  window.nacktEditorial = window.nacktEditorial || {};
  var LINKED_COLOURWAY_SCROLL_KEY = "nackt-linked-colourway-scroll";
  var LINKED_COLOURWAY_MEDIA_KEY = "nackt-linked-colourway-media";
  var SIZE_SYSTEM_STORAGE_KEY = "nackt-size-system";
  var SIZE_CHART_SYSTEM_STORAGE_KEY = "nackt-size-chart-system";
  var SIZE_SYSTEMS = ["eu", "uk", "us_m", "us_w"];
  var SIZE_CHART_SYSTEMS = ["uk", "us_w", "us_m"];
  var SIZE_CHART_MEASUREMENTS = ["foot_length", "internal_width"];
  var SIZE_SYSTEM_LABELS = {
    eu: "EU",
    uk: "UK",
    us_m: "US M",
    us_w: "US W"
  };
  var SIZE_CHART_MEASUREMENT_LABELS = {
    foot_length: "Foot length (mm)",
    internal_width: "Internal width (mm)"
  };
  var SIZE_SYSTEM_ATTRIBUTES = {
    eu: "data-nackt-size-eu",
    uk: "data-nackt-size-uk",
    us_m: "data-nackt-size-us-m",
    us_w: "data-nackt-size-us-w"
  };
  var LINKED_COLOURWAY_SCROLL_TTL = 30000;
  var formsTeaserDocumentObserver = null;
  var formsTeaserRootObserver = null;
  var formsTeaserObservedRoot = null;
  var formsTeaserScheduledSync = null;
  var formsTeaserPolling = null;
  var formsTeaserDiscoveryDelay = 250;
  var formsTeaserRootStyleState = null;
  var formsTeaserButtonStyleState = null;
  var formsPopupContainerElement = null;
  var formsPopupContainerStyleState = null;
  var formsPopupPanelElement = null;
  var formsPopupPanelStyleState = null;
  var formsPopupPresentationMode = null;
  var formsPopupMobileLayout = null;
  var formsPopupOverscrollRoot = null;
  var formsPopupOverscrollStyleState = null;
  var formsPopupViewport = null;
  var formsPopupViewportFrame = null;
  var formsPopupViewportWidth = null;
  var formsPopupViewportNormalHeight = 0;
  var formsPopupViewportOffset = 0;
  var formsPopupAncestorStyleStates = [];
  var formsPopupImageElement = null;
  var formsPopupImageStyleState = null;
  var formsPopupContentElement = null;
  var formsPopupContentStyleState = null;
  var formsPopupControlStyleStates = [];
  var formsPopupSpacingStyleStates = [];
  var formsPopupCloseWrapperElement = null;
  var formsPopupCloseWrapperStyleState = null;
  var importantStyleProbe = document.createElement("div").style;
  var desktopPdpPinFrame = null;
  var desktopPdpPinResizeObserver = null;
  var desktopPdpPinObservedSummary = null;
  var mobileContextualImageFrame = null;
  var mobileContextualImageResizeObserver = null;
  var mobileContextualImageObservedElements = [];
  var mobileContextualViewportFallback = null;
  var restockRocketPlacementObserver = null;
  var restockRocketObservedProduct = null;
  var restockRocketEventsBound = false;
  var desktopPdpScrollBound = false;
  var productLayoutEventsBound = false;
  var productLayoutBreakpoint = window.matchMedia("(min-width: 1024px)");
  var restockRocketPlacementFrame = null;
  var restockRocketRefreshTimer = null;
  var restockRocketRefreshVariantId = null;
  var restockRocketRefreshAttempts = 0;
  var restockRocketRefreshDelays = [80, 240, 560, 1100, 2000, 4000, 8000];

  initializeFormsTeaserObserver();

  function getStorage() {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function getPersistentStorage() {
    try {
      return window.localStorage;
    } catch (error) {
      return null;
    }
  }

  function getCurrentProductRoot() {
    return document.querySelector(".nackt-product-page[data-product-root]");
  }

  function getCurrentProductPath() {
    var productRoot = getCurrentProductRoot();

    if (!productRoot) {
      return window.location.pathname;
    }

    return productRoot.getAttribute("data-product-url-path") || window.location.pathname;
  }

  function getCurrentSelectedOptions() {
    var productRoot = getCurrentProductRoot();

    if (!productRoot) {
      return {
        option1: null,
        option2: null,
        option3: null
      };
    }

    return {
      option1: productRoot.getAttribute("data-current-option1") || null,
      option2: productRoot.getAttribute("data-current-option2") || null,
      option3: productRoot.getAttribute("data-current-option3") || null
    };
  }

  function getCurrentProductOptionNames() {
    var productRoot = getCurrentProductRoot();
    var rawOptionNames;

    if (!productRoot) {
      return [];
    }

    rawOptionNames = productRoot.getAttribute("data-product-option-names");

    if (!rawOptionNames) {
      return [];
    }

    try {
      return JSON.parse(rawOptionNames);
    } catch (error) {
      return [];
    }
  }

  function getSizeOptionIndex(optionNames) {
    var normalizedOptionNames = Array.isArray(optionNames) ? optionNames : [];

    return normalizedOptionNames.findIndex(function (optionName) {
      return typeof optionName === "string" && optionName.toLowerCase().indexOf("size") !== -1;
    });
  }

  function normalizeSizeSystem(sizeSystem) {
    if (SIZE_SYSTEMS.indexOf(sizeSystem) === -1) {
      return null;
    }

    return sizeSystem;
  }

  function getPreferredSizeSystem(defaultSizeSystem) {
    var storage = getPersistentStorage();
    var savedSizeSystem = storage ? storage.getItem(SIZE_SYSTEM_STORAGE_KEY) : null;

    return normalizeSizeSystem(savedSizeSystem)
      || normalizeSizeSystem(defaultSizeSystem)
      || "eu";
  }

  function savePreferredSizeSystem(sizeSystem) {
    var normalizedSizeSystem = normalizeSizeSystem(sizeSystem);
    var storage = getPersistentStorage();

    if (!normalizedSizeSystem || !storage) {
      return;
    }

    try {
      storage.setItem(SIZE_SYSTEM_STORAGE_KEY, normalizedSizeSystem);
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function getSizeLabel(labelEl, sizeSystem) {
    var attributeName = SIZE_SYSTEM_ATTRIBUTES[sizeSystem] || SIZE_SYSTEM_ATTRIBUTES.eu;
    var fallbackAttributeName = SIZE_SYSTEM_ATTRIBUTES.eu;

    if (!labelEl) {
      return "";
    }

    return labelEl.getAttribute(attributeName)
      || labelEl.getAttribute(fallbackAttributeName)
      || labelEl.textContent.trim();
  }

  function getSizePickerSelectedLabelEl(sizePicker) {
    var checkedInput = sizePicker.querySelector("input[data-single-option-selector]:checked");
    var selectedContainer;

    if (!checkedInput) {
      return null;
    }

    selectedContainer = checkedInput.closest(".label-only-input");

    return selectedContainer ? selectedContainer.querySelector("[data-nackt-size-label]") : null;
  }

  function updateStickyPurchaseSizeLabel(sizePicker) {
    var productRoot = sizePicker.closest("[data-product-root]") || document;
    var currentLabel = sizePicker.querySelector("[data-nackt-selected-size-label]");
    var stickyLabel = productRoot.querySelector("[data-nackt-sticky-selected-size]");
    var fallbackLabel;

    if (!stickyLabel) {
      return;
    }

    fallbackLabel = stickyLabel.getAttribute("data-nackt-sticky-size-fallback") || "";

    if (!currentLabel || !currentLabel.textContent.trim()) {
      stickyLabel.textContent = fallbackLabel;
      return;
    }

    stickyLabel.innerHTML = currentLabel.innerHTML;
  }

  function updateSizePickerCurrentLabel(sizePicker, sizeSystem) {
    var currentLabel = sizePicker.querySelector("[data-nackt-selected-size-label]");
    var selectedLabelEl = getSizePickerSelectedLabelEl(sizePicker);
    var normalizedSizeSystem = normalizeSizeSystem(sizeSystem) || "eu";
    var euSizeLabel;
    var convertedSizeLabel;
    var trueSizeSpan;
    var convertedSizeSpan;

    if (!currentLabel || !selectedLabelEl) {
      return;
    }

    euSizeLabel = getSizeLabel(selectedLabelEl, "eu");
    convertedSizeLabel = getSizeLabel(selectedLabelEl, normalizedSizeSystem);
    trueSizeSpan = document.createElement("span");
    trueSizeSpan.className = "nackt-size-system-current__true-size";
    trueSizeSpan.textContent = [SIZE_SYSTEM_LABELS.eu, euSizeLabel].join(" ");

    currentLabel.textContent = "";
    currentLabel.appendChild(trueSizeSpan);

    if (normalizedSizeSystem === "eu" || !convertedSizeLabel || convertedSizeLabel === euSizeLabel) {
      updateStickyPurchaseSizeLabel(sizePicker);
      return;
    }

    convertedSizeSpan = document.createElement("span");
    convertedSizeSpan.className = "nackt-size-system-current__converted-size";
    convertedSizeSpan.textContent = " (" + [SIZE_SYSTEM_LABELS[normalizedSizeSystem], convertedSizeLabel].join(" ") + ")";
    currentLabel.appendChild(convertedSizeSpan);
    updateStickyPurchaseSizeLabel(sizePicker);
  }

  function updateSizePicker(sizePicker, sizeSystem) {
    var normalizedSizeSystem = normalizeSizeSystem(sizeSystem) || "eu";

    sizePicker.setAttribute("data-nackt-size-system", normalizedSizeSystem);

    sizePicker.querySelectorAll("[data-nackt-size-label]").forEach(function (labelEl) {
      labelEl.textContent = getSizeLabel(labelEl, normalizedSizeSystem);
    });

    sizePicker.querySelectorAll("[data-nackt-size-system-button]").forEach(function (button) {
      var isActive = button.getAttribute("data-nackt-size-system-button") === normalizedSizeSystem;
      button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    updateSizePickerCurrentLabel(sizePicker, normalizedSizeSystem);
  }

  function updateAllSizePickers(sizeSystem, root) {
    var scope = root || document;
    var normalizedSizeSystem = normalizeSizeSystem(sizeSystem) || "eu";

    scope.querySelectorAll("[data-nackt-size-picker]").forEach(function (sizePicker) {
      updateSizePicker(sizePicker, normalizedSizeSystem);
    });
  }

  function initializeSizeSystemPicker(sizePicker) {
    var defaultSizeSystem = sizePicker.getAttribute("data-nackt-size-default-system");
    var preferredSizeSystem = getPreferredSizeSystem(defaultSizeSystem);

    if (sizePicker.getAttribute("data-nackt-size-picker-initialized") !== "true") {
      sizePicker.setAttribute("data-nackt-size-picker-initialized", "true");

      sizePicker.addEventListener("click", function (event) {
        var button = event.target.closest("[data-nackt-size-system-button]");
        var requestedSizeSystem;

        if (!button || !sizePicker.contains(button)) {
          return;
        }

        requestedSizeSystem = normalizeSizeSystem(button.getAttribute("data-nackt-size-system-button"));

        if (!requestedSizeSystem) {
          return;
        }

        savePreferredSizeSystem(requestedSizeSystem);
        updateAllSizePickers(requestedSizeSystem);
      });

      sizePicker.addEventListener("change", function () {
        updateSizePickerCurrentLabel(
          sizePicker,
          normalizeSizeSystem(sizePicker.getAttribute("data-nackt-size-system")) || preferredSizeSystem
        );
      });
    }

    updateSizePicker(sizePicker, preferredSizeSystem);
  }

  function initializeSizeSystemPickers(root) {
    var scope = root || document;

    scope.querySelectorAll("[data-nackt-size-picker]").forEach(initializeSizeSystemPicker);
  }

  function normalizeSizeChartSystem(sizeSystem) {
    return SIZE_CHART_SYSTEMS.indexOf(sizeSystem) === -1 ? null : sizeSystem;
  }

  function getPreferredSizeChartSystem() {
    var storage = getPersistentStorage();
    var savedSizeSystem = storage ? storage.getItem(SIZE_CHART_SYSTEM_STORAGE_KEY) : null;
    var sizePicker = document.querySelector("[data-nackt-size-picker]");
    var currentSizeSystem = sizePicker
      ? sizePicker.getAttribute("data-nackt-size-system")
      : null;

    return normalizeSizeChartSystem(savedSizeSystem)
      || normalizeSizeChartSystem(currentSizeSystem)
      || "uk";
  }

  function savePreferredSizeChartSystem(sizeSystem) {
    var normalizedSizeSystem = normalizeSizeChartSystem(sizeSystem);
    var storage = getPersistentStorage();

    if (!normalizedSizeSystem || !storage) {
      return;
    }

    try {
      storage.setItem(SIZE_CHART_SYSTEM_STORAGE_KEY, normalizedSizeSystem);
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function normalizeSizeChartHeading(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function getSizeChartConversionColumns(headerRow) {
    var columns = {};

    Array.from(headerRow.cells).forEach(function (cell, index) {
      var heading = normalizeSizeChartHeading(cell.textContent);

      if (heading === "uk") {
        columns.uk = index;
      } else if (heading === "usm" || heading === "usmen") {
        columns.us_m = index;
      } else if (heading === "usw" || heading === "uswomen") {
        columns.us_w = index;
      } else if (heading === "footlength" || heading === "footlengthmm") {
        columns.foot_length = index;
      } else if (heading === "internalwidth" || heading === "internalwidthmm") {
        columns.internal_width = index;
      }
    });

    return columns;
  }

  function initializeDynamicSizeChart(root) {
    var table = root ? root.querySelector("table") : null;
    var rows;
    var headerRow;
    var columns;
    var conversionValues;
    var conversionCellIndex;
    var measurementValues;
    var measurementCellIndex;
    var hasMeasurementColumns;
    var select;
    var measurementSelect;
    var preferredSizeSystem;
    var tableWrapper;

    if (!table || table.getAttribute("data-nackt-dynamic-size-chart") === "true") {
      return;
    }

    rows = Array.from(table.rows);
    headerRow = rows[0];

    if (!headerRow) {
      return;
    }

    columns = getSizeChartConversionColumns(headerRow);

    if (
      columns.uk === undefined
      || columns.us_m === undefined
      || columns.us_w === undefined
    ) {
      return;
    }

    conversionCellIndex = columns.uk;
    measurementCellIndex = columns.foot_length;
    hasMeasurementColumns = (
      columns.foot_length !== undefined
      && columns.internal_width !== undefined
    );
    conversionValues = rows.map(function (row) {
      return {
        uk: row.cells[columns.uk] ? row.cells[columns.uk].textContent.trim() : "",
        us_m: row.cells[columns.us_m] ? row.cells[columns.us_m].textContent.trim() : "",
        us_w: row.cells[columns.us_w] ? row.cells[columns.us_w].textContent.trim() : ""
      };
    });
    measurementValues = hasMeasurementColumns
      ? rows.map(function (row) {
          return {
            foot_length: row.cells[columns.foot_length]
              ? row.cells[columns.foot_length].textContent.trim()
              : "",
            internal_width: row.cells[columns.internal_width]
              ? row.cells[columns.internal_width].textContent.trim()
              : ""
          };
        })
      : [];

    rows.forEach(function (row) {
      if (row.cells[columns.us_m]) {
        row.cells[columns.us_m].hidden = true;
      }

      if (row.cells[columns.us_w]) {
        row.cells[columns.us_w].hidden = true;
      }

      if (row.cells[conversionCellIndex]) {
        row.cells[conversionCellIndex].classList.add("nackt-size-chart-conversion-cell");
      }
    });

    select = document.createElement("select");
    select.className = "nackt-size-chart-system-select";
    select.setAttribute("aria-label", "Size conversion system");

    SIZE_CHART_SYSTEMS.forEach(function (sizeSystem) {
      var option = document.createElement("option");
      option.value = sizeSystem;
      option.textContent = SIZE_SYSTEM_LABELS[sizeSystem];
      select.appendChild(option);
    });

    function updateConversionColumn(sizeSystem) {
      var normalizedSizeSystem = normalizeSizeChartSystem(sizeSystem) || "uk";

      rows.slice(1).forEach(function (row, rowIndex) {
        var targetCell = row.cells[conversionCellIndex];
        var rowValues = conversionValues[rowIndex + 1];

        if (targetCell && rowValues) {
          targetCell.textContent = rowValues[normalizedSizeSystem];
        }
      });

      select.value = normalizedSizeSystem;
      headerRow.cells[conversionCellIndex].setAttribute(
        "data-nackt-size-chart-system-label",
        SIZE_SYSTEM_LABELS[normalizedSizeSystem]
      );
      table.setAttribute("data-nackt-size-chart-system", normalizedSizeSystem);
    }

    select.addEventListener("change", function () {
      savePreferredSizeChartSystem(select.value);
      updateConversionColumn(select.value);
    });

    headerRow.cells[conversionCellIndex].textContent = "";
    headerRow.cells[conversionCellIndex].classList.add("nackt-size-chart-conversion-header");
    headerRow.cells[conversionCellIndex].appendChild(select);

    if (hasMeasurementColumns) {
      var measurementHeaderCell = headerRow.cells[measurementCellIndex];
      var measurementDesktopLabel = document.createElement("span");

      rows.forEach(function (row, rowIndex) {
        var targetCell = row.cells[measurementCellIndex];
        var alternateCell = row.cells[columns.internal_width];
        var footLengthValue;
        var internalWidthValue;

        if (alternateCell) {
          alternateCell.classList.add("nackt-size-chart-mobile-alternate-column");
        }

        if (rowIndex === 0 || !targetCell) {
          return;
        }

        footLengthValue = document.createElement("span");
        footLengthValue.className = "nackt-size-chart-measurement-value nackt-size-chart-measurement-value--foot-length";
        footLengthValue.textContent = measurementValues[rowIndex].foot_length;

        internalWidthValue = document.createElement("span");
        internalWidthValue.className = "nackt-size-chart-measurement-value nackt-size-chart-measurement-value--internal-width";
        internalWidthValue.textContent = measurementValues[rowIndex].internal_width;

        targetCell.textContent = "";
        targetCell.appendChild(footLengthValue);
        targetCell.appendChild(internalWidthValue);
      });

      measurementSelect = document.createElement("select");
      measurementSelect.className = "nackt-size-chart-measurement-select";
      measurementSelect.setAttribute("aria-label", "Size measurement");

      SIZE_CHART_MEASUREMENTS.forEach(function (measurement) {
        var option = document.createElement("option");
        option.value = measurement;
        option.textContent = SIZE_CHART_MEASUREMENT_LABELS[measurement];
        measurementSelect.appendChild(option);
      });

      measurementDesktopLabel.className = "nackt-size-chart-measurement-desktop-label";

      while (measurementHeaderCell.firstChild) {
        measurementDesktopLabel.appendChild(measurementHeaderCell.firstChild);
      }

      measurementHeaderCell.classList.add("nackt-size-chart-measurement-header");
      measurementHeaderCell.appendChild(measurementDesktopLabel);
      measurementHeaderCell.appendChild(measurementSelect);
      table.setAttribute("data-nackt-size-chart-measurement", "foot_length");
      measurementSelect.value = "foot_length";

      measurementSelect.addEventListener("change", function () {
        table.setAttribute("data-nackt-size-chart-measurement", measurementSelect.value);
      });
    }

    table.classList.add("nackt-dynamic-size-chart");
    table.setAttribute("data-nackt-dynamic-size-chart", "true");
    tableWrapper = table.closest(".rte__table");

    if (tableWrapper) {
      tableWrapper.classList.add("nackt-dynamic-size-chart-wrapper");
    }

    preferredSizeSystem = getPreferredSizeChartSystem();
    updateConversionColumn(preferredSizeSystem);
  }

  window.nacktEditorial.initializeDynamicSizeChart = initializeDynamicSizeChart;

  function saveLinkedColourwayScroll(targetHref) {
    var storage = getStorage();
    var currentPath = getCurrentProductPath();
    var targetUrl;

    if (!storage || !targetHref || window.scrollY <= 0) {
      return;
    }

    try {
      targetUrl = new URL(targetHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (targetUrl.pathname === currentPath) {
      return;
    }

    try {
      storage.setItem(
        LINKED_COLOURWAY_SCROLL_KEY,
        JSON.stringify({
          scrollY: window.scrollY,
          targetPath: targetUrl.pathname,
          sourcePath: currentPath,
          timestamp: Date.now()
        })
      );
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function getCurrentLinkedColourwayMediaIndex() {
    var productRoot = document.querySelector(".nackt-product-page[data-linked-colourway-media-index]");
    var rawIndex;
    var parsedIndex;

    if (!productRoot) {
      return 0;
    }

    rawIndex = productRoot.getAttribute("data-linked-colourway-media-index");
    parsedIndex = parseInt(rawIndex, 10);

    if (Number.isNaN(parsedIndex) || parsedIndex < 0) {
      return 0;
    }

    return parsedIndex;
  }

  function saveLinkedColourwayMedia(targetHref) {
    var storage = getStorage();
    var currentPath = getCurrentProductPath();
    var targetUrl;

    if (!storage || !targetHref) {
      return;
    }

    try {
      targetUrl = new URL(targetHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (targetUrl.pathname === currentPath) {
      return;
    }

    try {
      storage.setItem(
        LINKED_COLOURWAY_MEDIA_KEY,
        JSON.stringify({
          mediaIndex: getCurrentLinkedColourwayMediaIndex(),
          targetPath: targetUrl.pathname,
          sourcePath: currentPath,
          timestamp: Date.now()
        })
      );
    } catch (error) {
      // Ignore storage failures.
    }
  }

  function restoreLinkedColourwayScroll() {
    var storage = getStorage();
    var rawValue;
    var payload;

    if (!storage || !document.querySelector(".nackt-product-page")) {
      return;
    }

    rawValue = storage.getItem(LINKED_COLOURWAY_SCROLL_KEY);

    if (!rawValue) {
      return;
    }

    try {
      payload = JSON.parse(rawValue);
    } catch (error) {
      storage.removeItem(LINKED_COLOURWAY_SCROLL_KEY);
      return;
    }

    if (
      !payload
      || payload.targetPath !== window.location.pathname
      || typeof payload.scrollY !== "number"
      || Date.now() - payload.timestamp > LINKED_COLOURWAY_SCROLL_TTL
    ) {
      storage.removeItem(LINKED_COLOURWAY_SCROLL_KEY);
      return;
    }

    storage.removeItem(LINKED_COLOURWAY_SCROLL_KEY);

    if (window.history && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    window.scrollTo(0, payload.scrollY);
    window.requestAnimationFrame(function () {
      window.scrollTo(0, payload.scrollY);
    });
  }

  function clearLinkedColourwayScroll() {
    var storage = getStorage();

    if (!storage) {
      return;
    }

    storage.removeItem(LINKED_COLOURWAY_SCROLL_KEY);
  }

  function isMobileViewport() {
    return window.matchMedia && window.matchMedia("(max-width: 1023px)").matches;
  }

  function getHeaderOffset() {
    var stickyHeader = document.querySelector("[data-theme-header]");
    var stickyHeaderSection = stickyHeader ? stickyHeader.closest(".shopify-section") : null;
    var brandTicker = document.querySelector(".nackt-brand-ticker");
    var brandTickerSection = brandTicker ? brandTicker.closest(".shopify-section-group-header-group") : null;
    var computedDocument = window.getComputedStyle(document.documentElement);
    var computedBody = window.getComputedStyle(document.body);
    var stickyHeaderHeight = parseFloat(computedDocument.getPropertyValue("--sticky-header-height"))
      || parseFloat(computedBody.getPropertyValue("--sticky-header-height"))
      || 0;
    var offset = stickyHeaderHeight;
    var stickyHeaderRect;
    var brandTickerRect;

    if (stickyHeaderSection) {
      stickyHeaderRect = stickyHeaderSection.getBoundingClientRect();

      if (stickyHeaderRect.bottom > 0) {
        offset = Math.max(offset, stickyHeaderRect.bottom);
      }
    }

    if (brandTickerSection) {
      brandTickerRect = brandTickerSection.getBoundingClientRect();

      if (brandTickerRect.bottom > 0) {
        offset = Math.max(offset, brandTickerRect.bottom);
      }
    }

    return offset;
  }

  function getElementOuterHeight(element) {
    var rect;
    var styles;

    if (!element) {
      return 0;
    }

    rect = element.getBoundingClientRect();
    styles = window.getComputedStyle(element);

    return rect.height
      + (parseFloat(styles.marginTop) || 0)
      + (parseFloat(styles.marginBottom) || 0);
  }

  function getStableMobileHeaderHeight(stickyHeaderSection, brandTickerSection) {
    var computedDocument = window.getComputedStyle(document.documentElement);
    var headerGroupHeight = parseFloat(
      computedDocument.getPropertyValue("--header-group-height")
    );

    if (headerGroupHeight > 0) {
      return headerGroupHeight;
    }

    return getElementOuterHeight(stickyHeaderSection)
      + getElementOuterHeight(brandTickerSection);
  }

  function observeMobileContextualImageLayout(elements) {
    var observedElements = elements.filter(Boolean);
    var observationsMatch = observedElements.length === mobileContextualImageObservedElements.length
      && observedElements.every(function (element, index) {
        return element === mobileContextualImageObservedElements[index];
      });

    if (!window.ResizeObserver || observationsMatch) {
      return;
    }

    if (!mobileContextualImageResizeObserver) {
      mobileContextualImageResizeObserver = new window.ResizeObserver(function () {
        scheduleMobileContextualImageSync();
      });
    } else {
      mobileContextualImageResizeObserver.disconnect();
    }

    mobileContextualImageObservedElements = observedElements;
    observedElements.forEach(function (element) {
      mobileContextualImageResizeObserver.observe(element);
    });
  }

  function clearMobileContextualImageHeight(productRoot) {
    var root = productRoot || getCurrentProductRoot();

    if (root) {
      root.style.removeProperty("--nackt-mobile-contextual-image-height");
    }
  }

  function getStableMobileContextualViewportHeight() {
    // Safari's toolbar and keyboard resize visualViewport during a scroll.
    // The small viewport stays stable until the device viewport itself changes.
    if (window.CSS?.supports("height", "100svh")) return "100svh";
    var width = document.documentElement.clientWidth;
    if (!mobileContextualViewportFallback || mobileContextualViewportFallback.width !== width) {
      mobileContextualViewportFallback = { width: width, height: window.innerHeight };
    }
    return mobileContextualViewportFallback.height + "px";
  }

  function syncMobileContextualImageHeight() {
    var productRoot = getCurrentProductRoot();
    var contextualImage;
    var stickyTray;
    var titleBlock;
    var content;
    var mediaContainer;
    var mediaIndicator;
    var stickyHeader;
    var stickyHeaderSection;
    var brandTicker;
    var brandTickerSection;
    var viewportHeight;
    var headerHeight;
    var trayHeight;
    var contentRect;
    var titleRect;
    var titleHeight;
    var mediaContainerStyles;
    var mediaChromeHeight;
    var imageHeight;

    mobileContextualImageFrame = null;

    if (!productRoot || !isMobileViewport()) {
      clearMobileContextualImageHeight(productRoot);
      return;
    }

    contextualImage = productRoot.querySelector('[data-nackt-contextual-product-image="true"]');
    stickyTray = productRoot.querySelector(".nackt-mobile-sticky-purchase-tray");
    titleBlock = productRoot.querySelector(".nackt-product-form__block--title");
    content = productRoot.querySelector(".nackt-product-page__content");
    mediaContainer = productRoot.querySelector(".nackt-product-page__media");
    mediaIndicator = productRoot.querySelector(".nackt-product-media-indicator");

    if (!contextualImage || !stickyTray || !titleBlock || !content || !mediaContainer) {
      clearMobileContextualImageHeight(productRoot);
      return;
    }

    stickyHeader = document.querySelector("[data-theme-header]");
    stickyHeaderSection = stickyHeader ? stickyHeader.closest(".shopify-section") : null;
    brandTicker = document.querySelector(".nackt-brand-ticker");
    brandTickerSection = brandTicker ? brandTicker.closest(".shopify-section-group-header-group") : null;

    observeMobileContextualImageLayout([
      stickyHeaderSection,
      brandTickerSection,
      stickyTray,
      titleBlock,
      mediaIndicator
    ]);

    viewportHeight = getStableMobileContextualViewportHeight();
    headerHeight = getStableMobileHeaderHeight(stickyHeaderSection, brandTickerSection);
    trayHeight = stickyTray.getBoundingClientRect().height;
    contentRect = content.getBoundingClientRect();
    titleRect = titleBlock.getBoundingClientRect();
    titleHeight = Math.max(0, titleRect.bottom - contentRect.top);
    mediaContainerStyles = window.getComputedStyle(mediaContainer);
    mediaChromeHeight = getElementOuterHeight(mediaIndicator)
      + (parseFloat(mediaContainerStyles.paddingTop) || 0)
      + (parseFloat(mediaContainerStyles.paddingBottom) || 0)
      + (parseFloat(mediaContainerStyles.borderTopWidth) || 0)
      + (parseFloat(mediaContainerStyles.borderBottomWidth) || 0);
    imageHeight = "max(var(--nackt-mobile-product-photo-crop-height, 63vw), calc("
      + viewportHeight + " - " + Math.ceil(headerHeight + trayHeight + titleHeight + mediaChromeHeight) + "px))";

    if (
      productRoot.style.getPropertyValue("--nackt-mobile-contextual-image-height")
      !== imageHeight
    ) {
      productRoot.style.setProperty("--nackt-mobile-contextual-image-height", imageHeight);
    }
  }

  function scheduleMobileContextualImageSync() {
    if (!getCurrentProductRoot()) return;
    if (mobileContextualImageFrame) {
      return;
    }

    mobileContextualImageFrame = window.requestAnimationFrame(syncMobileContextualImageHeight);
  }

  function clearDesktopPdpPin(productRoot) {
    var root = productRoot || getCurrentProductRoot();

    if (!root) {
      return;
    }

    root.removeAttribute("data-desktop-pdp-pin");
    root.style.removeProperty("--nackt-pdp-summary-height");
    root.style.removeProperty("--nackt-pdp-form-left");
    root.style.removeProperty("--nackt-pdp-form-width");
  }

  function observeDesktopPdpSummary(summary) {
    if (!window.ResizeObserver) {
      return;
    }

    if (desktopPdpPinObservedSummary === summary) {
      return;
    }

    if (desktopPdpPinResizeObserver) {
      desktopPdpPinResizeObserver.disconnect();
    }

    desktopPdpPinObservedSummary = summary;
    desktopPdpPinResizeObserver = new window.ResizeObserver(function () {
      scheduleDesktopPdpPinSync();
    });
    desktopPdpPinResizeObserver.observe(summary);
  }

  function syncDesktopPdpPin() {
    var productRoot = getCurrentProductRoot();
    var summary;
    var formSurface;
    var summaryRect;
    var formSurfaceRect;
    var formWrapper;
    var formWrapperStyles;
    var formWrapperPaddingTop;
    var formWrapperPaddingBottom;
    var pinnedSurfaceHeight;
    var content;
    var contentRect;
    var contentStyles;
    var contentPaddingLeft;
    var contentPaddingRight;
    var contentBorderLeft;
    var contentBorderRight;
    var pinLeft;
    var pinWidth;
    var rootRect;
    var headerOffset;
    var pinState;

    desktopPdpPinFrame = null;

    if (!productRoot || isMobileViewport()) {
      clearDesktopPdpPin(productRoot);
      return;
    }

    summary = productRoot.querySelector(".nackt-product-form__sticky-summary");

    if (!summary) {
      clearDesktopPdpPin(productRoot);
      return;
    }

    formSurface = productRoot.querySelector(".nackt-product-form") || summary;
    observeDesktopPdpSummary(formSurface);
    formWrapper = productRoot.querySelector(".nackt-product-page__form");
    content = productRoot.querySelector(".nackt-product-page__content");
    summaryRect = summary.getBoundingClientRect();
    formSurfaceRect = formSurface.getBoundingClientRect();
    formWrapperStyles = formWrapper ? window.getComputedStyle(formWrapper) : null;
    formWrapperPaddingTop = formWrapperStyles ? parseFloat(formWrapperStyles.paddingTop) || 0 : 0;
    formWrapperPaddingBottom = formWrapperStyles ? parseFloat(formWrapperStyles.paddingBottom) || 0 : 0;
    pinnedSurfaceHeight = formSurfaceRect.height + formWrapperPaddingTop + formWrapperPaddingBottom;
    contentRect = content ? content.getBoundingClientRect() : null;
    rootRect = productRoot.getBoundingClientRect();
    headerOffset = getHeaderOffset();

    productRoot.style.setProperty("--nackt-pdp-pin-top", headerOffset + "px");
    productRoot.style.setProperty("--nackt-pdp-summary-height", Math.ceil(summaryRect.height) + "px");

    if (contentRect) {
      contentStyles = window.getComputedStyle(content);
      contentPaddingLeft = parseFloat(contentStyles.paddingLeft) || 0;
      contentPaddingRight = parseFloat(contentStyles.paddingRight) || 0;
      contentBorderLeft = parseFloat(contentStyles.borderLeftWidth) || 0;
      contentBorderRight = parseFloat(contentStyles.borderRightWidth) || 0;
      pinLeft = contentRect.left + contentBorderLeft + contentPaddingLeft;
      pinWidth = contentRect.width - contentBorderLeft - contentBorderRight - contentPaddingLeft - contentPaddingRight;

      productRoot.style.setProperty("--nackt-pdp-form-left", pinLeft + "px");
      productRoot.style.setProperty("--nackt-pdp-form-width", Math.max(0, pinWidth) + "px");
    }

    if (window.scrollY <= 0 || rootRect.top > headerOffset) {
      pinState = null;
    } else if (rootRect.bottom > headerOffset + pinnedSurfaceHeight) {
      pinState = "fixed";
    } else if (rootRect.bottom > 0) {
      pinState = "bottom";
    } else {
      pinState = null;
    }

    if (pinState) {
      productRoot.setAttribute("data-desktop-pdp-pin", pinState);
    } else {
      productRoot.removeAttribute("data-desktop-pdp-pin");
    }
  }

  function scheduleDesktopPdpPinSync() {
    if (!getCurrentProductRoot()) return;
    if (desktopPdpPinFrame) {
      return;
    }

    desktopPdpPinFrame = window.requestAnimationFrame(syncDesktopPdpPin);
  }

  function getFormsRoot() {
    if (formsTeaserObservedRoot && formsTeaserObservedRoot.isConnected) {
      return formsTeaserObservedRoot;
    }

    return findFormsRoot(document);
  }

  function findFormsRoot(rootNode) {
    var formsRoot;
    var elements;
    var index;
    var nestedFormsRoot;

    if (!rootNode || typeof rootNode.querySelector !== "function") {
      return null;
    }

    formsRoot = rootNode.querySelector("#app-embed[data-form-root='true']");

    if (formsRoot) {
      return formsRoot;
    }

    if (typeof rootNode.querySelectorAll !== "function") {
      return null;
    }

    elements = rootNode.querySelectorAll("shopify-forms-embed");

    for (index = 0; index < elements.length; index += 1) {
      if (!elements[index].shadowRoot) {
        continue;
      }

      nestedFormsRoot = findFormsRoot(elements[index].shadowRoot);

      if (nestedFormsRoot) {
        return nestedFormsRoot;
      }
    }

    return null;
  }

  function getFormsTeaserButton(root) {
    if (!root) {
      return null;
    }

    return root.querySelector(
      "button[aria-haspopup='dialog'][aria-label='Join the club'], ._teaserContainer_trejf_5"
    );
  }

  function setImportantStyle(element, property, value) {
    var currentValue;
    var currentPriority;

    if (!element) {
      return;
    }

    if (value === null || value === undefined || value === "") {
      if (!element.style.getPropertyValue(property)) {
        return;
      }

      element.style.removeProperty(property);
      return;
    }

    currentValue = element.style.getPropertyValue(property);
    currentPriority = element.style.getPropertyPriority(property);

    if (currentPriority === "important") {
      if (currentValue === value) {
        return;
      }
      importantStyleProbe.cssText = "";
      importantStyleProbe.setProperty(property, value);
      if (currentValue === importantStyleProbe.getPropertyValue(property)) {
        return;
      }
    }

    element.style.setProperty(property, value, "important");
  }

  function captureInlineStyleState(element, properties) {
    if (!element) {
      return [];
    }

    return properties.map(function (property) {
      return {
        property: property,
        value: element.style.getPropertyValue(property),
        priority: element.style.getPropertyPriority(property)
      };
    });
  }

  function restoreInlineStyleState(element, styleState) {
    if (!element || !styleState) {
      return;
    }

    styleState.forEach(function (entry) {
      if (entry.value) {
        element.style.setProperty(entry.property, entry.value, entry.priority);
      } else {
        element.style.removeProperty(entry.property);
      }
    });
  }

  function restoreFormsPopupOverscroll() {
    if (!formsPopupOverscrollRoot) {
      return;
    }
    restoreInlineStyleState(formsPopupOverscrollRoot, formsPopupOverscrollStyleState);
    formsPopupOverscrollRoot = null;
    formsPopupOverscrollStyleState = null;
  }

  function syncFormsPopupOverscroll(mobileViewport) {
    var root = document.documentElement;

    if (!mobileViewport || formsPopupOverscrollRoot !== root) {
      restoreFormsPopupOverscroll();
    }
    if (!mobileViewport || !root) {
      return;
    }
    if (!formsPopupOverscrollRoot) {
      formsPopupOverscrollRoot = root;
      formsPopupOverscrollStyleState = captureInlineStyleState(root, ["overscroll-behavior-y"]);
    }
    // Keep native page/country scrolling; suppress only vertical root boundary actions.
    setImportantStyle(root, "overscroll-behavior-y", "none");
  }

  function clearFormsPopupViewport() {
    if (formsPopupViewport) {
      formsPopupViewport.removeEventListener("scroll", scheduleFormsPopupViewportSync);
      formsPopupViewport.removeEventListener("resize", scheduleFormsPopupViewportSync);
    }
    if (formsPopupViewportFrame !== null) {
      window.cancelAnimationFrame(formsPopupViewportFrame);
    }
    formsPopupViewport = null;
    formsPopupViewportFrame = null;
    formsPopupViewportWidth = null;
    formsPopupViewportNormalHeight = 0;
    formsPopupViewportOffset = 0;
  }

  function getFormsPopupViewportTransform() {
    return formsPopupViewportOffset > 0
      ? "translate(-50%, " + formsPopupViewportOffset + "px) scale(0.9)"
      : "translateX(-50%) scale(0.9)";
  }

  function syncFormsPopupViewportOffset() {
    var viewport = formsPopupViewport;
    var panel = formsPopupPanelElement;
    var layoutHeight;
    var normalScale;
    var keyboardSized;
    var nextOffset;

    formsPopupViewportFrame = null;
    if (!viewport || !panel || !panel.isConnected || !isMobileViewport()) {
      clearFormsPopupViewport();
      return;
    }

    layoutHeight = Math.max(window.innerHeight, document.documentElement.clientHeight, viewport.height);
    normalScale = Math.abs(viewport.scale - 1) <= 0.01;
    if (formsPopupViewportWidth !== window.innerWidth) {
      formsPopupViewportWidth = window.innerWidth;
      formsPopupViewportNormalHeight = layoutHeight;
    }
    if (normalScale) {
      formsPopupViewportNormalHeight = Math.max(formsPopupViewportNormalHeight, layoutHeight);
    }
    keyboardSized = formsPopupViewportNormalHeight - viewport.height > Math.max(120, formsPopupViewportNormalHeight * 0.2);
    nextOffset = normalScale && !keyboardSized ? Math.max(0, viewport.offsetTop) : 0;
    if (nextOffset !== formsPopupViewportOffset) {
      formsPopupViewportOffset = nextOffset;
      setImportantStyle(panel, "transform", getFormsPopupViewportTransform());
    }
  }

  function scheduleFormsPopupViewportSync() {
    if (formsPopupViewportFrame === null) {
      formsPopupViewportFrame = window.requestAnimationFrame(syncFormsPopupViewportOffset);
    }
  }

  function syncFormsPopupViewport(mobileViewport) {
    var viewport = window.visualViewport;

    if (!mobileViewport || !viewport) {
      clearFormsPopupViewport();
      return;
    }
    if (formsPopupViewport !== viewport) {
      clearFormsPopupViewport();
      formsPopupViewport = viewport;
      viewport.addEventListener("scroll", scheduleFormsPopupViewportSync, { passive: true });
      viewport.addEventListener("resize", scheduleFormsPopupViewportSync, { passive: true });
    }
    if (formsPopupViewportFrame !== null) {
      window.cancelAnimationFrame(formsPopupViewportFrame);
    }
    syncFormsPopupViewportOffset();
  }

  function clearFormsPopupPresentation() {
    restoreFormsPopupAncestors();
    clearFormsPopupViewport();
    restoreFormsPopupOverscroll();
    restoreInlineStyleState(formsPopupContainerElement, formsPopupContainerStyleState);

    if (formsPopupPanelElement) {
      restoreInlineStyleState(formsPopupPanelElement, formsPopupPanelStyleState);
    }

    if (formsPopupImageElement) {
      restoreInlineStyleState(formsPopupImageElement, formsPopupImageStyleState);
    }

    restoreInlineStyleState(formsPopupContentElement, formsPopupContentStyleState);
    formsPopupControlStyleStates.forEach(function (entry) {
      restoreInlineStyleState(entry.element, entry.styles);
    });
    formsPopupSpacingStyleStates.forEach(function (entry) {
      restoreInlineStyleState(entry.element, entry.styles);
    });

    if (formsPopupCloseWrapperElement) {
      restoreInlineStyleState(
        formsPopupCloseWrapperElement,
        formsPopupCloseWrapperStyleState
      );
    }

    formsPopupContainerElement = null;
    formsPopupContainerStyleState = null;
    formsPopupPanelElement = null;
    formsPopupPanelStyleState = null;
    formsPopupPresentationMode = null;
    formsPopupMobileLayout = null;
    formsPopupImageElement = null;
    formsPopupImageStyleState = null;
    formsPopupContentElement = null;
    formsPopupContentStyleState = null;
    formsPopupControlStyleStates = [];
    formsPopupSpacingStyleStates = [];
    formsPopupCloseWrapperElement = null;
    formsPopupCloseWrapperStyleState = null;
  }

  function getFormsPopupMobileLayout(mobileViewport) {
    if (!mobileViewport) {
      formsPopupMobileLayout = null;
      return null;
    }
    var width = window.innerWidth;
    var orientation = window.screen?.orientation?.angle ?? window.orientation ?? 0;
    if (formsPopupMobileLayout?.width === width && formsPopupMobileLayout.orientation === orientation) {
      return formsPopupMobileLayout;
    }
    // Some browser shells resize the whole web view with their toolbars, including svh.
    // Resolve viewport units and safe areas once per opening/width/orientation, not per scroll.
    var probe = document.createElement("div");
    probe.style.cssText = "position:fixed;left:-9999px;top:0;width:0;visibility:hidden;pointer-events:none;box-sizing:content-box";
    probe.style.height = window.CSS?.supports("height", "100svh") ? "100svh" : window.innerHeight + "px";
    probe.style.paddingTop = "env(safe-area-inset-top, 0px)";
    probe.style.paddingBottom = "env(safe-area-inset-bottom, 0px)";
    document.body.appendChild(probe);
    var styles = window.getComputedStyle(probe);
    formsPopupMobileLayout = {
      width: width,
      orientation: orientation,
      height: parseFloat(styles.height) || window.innerHeight,
      top: Math.max(12, parseFloat(styles.paddingTop) || 0),
      bottom: Math.max(12, parseFloat(styles.paddingBottom) || 0)
    };
    probe.remove();
    return formsPopupMobileLayout;
  }

  function syncFormsPopupPresentation(root) {
    var closeButton;
    var panel;
    var popupContainer;
    var imageElement;
    var formElement;
    var contentElement;
    var closeWrapper;
    var mobileViewport;
    var mobileLayout;
    var countryButton;
    var phoneInput;
    var presentationMode;
    var presentationChanged;

    if (
      !root
      || root.getAttribute("data-current-step") !== "form"
    ) {
      clearFormsPopupPresentation();
      return false;
    }

    closeButton = root.querySelector(
      "[role='button'][aria-label='Close modal'], button[aria-label='Close modal']"
    );
    panel = closeButton && closeButton.closest("section[role='dialog']");

    if (!panel) {
      clearFormsPopupPresentation();
      return false;
    }

    releaseMenuForFormsPopup(root, panel);

    popupContainer = panel.closest("[class*='appEmbedRoot']");
    imageElement = panel.querySelector("[style*='background-image']");
    formElement = panel.querySelector("form");
    contentElement = formElement && formElement.parentElement;
    closeWrapper = closeButton.parentElement;
    mobileViewport = isMobileViewport();

    if (
      formsPopupContainerElement !== popupContainer
      || formsPopupPanelElement !== panel
      || formsPopupImageElement !== imageElement
      || formsPopupContentElement !== contentElement
      || formsPopupCloseWrapperElement !== closeWrapper
    ) {
      clearFormsPopupPresentation();
      formsPopupContainerElement = popupContainer;
      formsPopupContainerStyleState = captureInlineStyleState(popupContainer, [
        "position",
        "top",
        "right",
        "bottom",
        "left",
        "width",
        "max-width",
        "max-height",
        "transform",
        "z-index"
      ]);
      formsPopupPanelElement = panel;
      formsPopupPanelStyleState = captureInlineStyleState(panel, [
        "position",
        "top",
        "right",
        "bottom",
        "left",
        "width",
        "max-width",
        "max-height",
        "height",
        "min-width",
        "display",
        "flex-direction",
        "transform",
        "transform-origin",
        "z-index",
        "overflow-x",
        "overflow-y",
        "overscroll-behavior-y",
        "-webkit-overflow-scrolling"
      ]);
      formsPopupImageElement = imageElement;
      formsPopupImageStyleState = captureInlineStyleState(imageElement, [
        "background-position", "height", "min-height", "flex", "width"
      ]);
      formsPopupContentElement = contentElement;
      formsPopupContentStyleState = captureInlineStyleState(contentElement, [
        "padding", "flex", "min-width"
      ]);
      if (contentElement) {
        formsPopupSpacingStyleStates = [formElement, contentElement.firstElementChild, contentElement.lastElementChild, formElement.firstElementChild, formElement.querySelector("button[type='submit']")].map(function (element) {
          return { element: element, styles: captureInlineStyleState(element, ["margin", "gap", "display", "grid-template-columns", "grid-column"]) };
        });
      }
      formsPopupCloseWrapperElement = closeWrapper;
      formsPopupCloseWrapperStyleState = captureInlineStyleState(closeWrapper, [
        "position",
        "top",
        "right",
        "bottom",
        "left",
        "z-index"
      ]);
    }

    mobileLayout = getFormsPopupMobileLayout(mobileViewport);
    presentationMode = !mobileViewport ? "desktop" : mobileLayout.height <= 519
      ? (mobileLayout.width >= 600 ? "compact-wide" : "compact") : "mobile";
    syncFormsPopupOverscroll(mobileViewport);
    syncFormsPopupViewport(mobileViewport);
    presentationChanged = formsPopupPresentationMode !== presentationMode;
    formsPopupPresentationMode = presentationMode;
    if (presentationChanged) {
      restoreInlineStyleState(popupContainer, formsPopupContainerStyleState);
      formsPopupSpacingStyleStates.forEach(function (entry) {
        restoreInlineStyleState(entry.element, entry.styles);
      });
    }
    setImportantStyle(popupContainer, "z-index", "2147483646");

    if (!mobileViewport) {
      restoreFormsPopupAncestors();
      // Remove mobile sizing before applying the app's desktop grid again.
      if (presentationChanged) {
        restoreInlineStyleState(panel, formsPopupPanelStyleState);
        restoreInlineStyleState(imageElement, formsPopupImageStyleState);
        restoreInlineStyleState(contentElement, formsPopupContentStyleState);
        restoreInlineStyleState(closeWrapper, formsPopupCloseWrapperStyleState);
        formsPopupControlStyleStates.forEach(function (entry) {
          restoreInlineStyleState(entry.element, entry.styles);
        });
      }
      setImportantStyle(popupContainer, "position", "fixed");
      setImportantStyle(popupContainer, "top", "50%");
      setImportantStyle(popupContainer, "right", "auto");
      setImportantStyle(popupContainer, "bottom", "auto");
      setImportantStyle(popupContainer, "left", "50%");
      setImportantStyle(popupContainer, "width", "auto");
      setImportantStyle(popupContainer, "max-width", "calc(100vw - 48px)");
      setImportantStyle(popupContainer, "max-height", "calc(100dvh - 48px)");
      setImportantStyle(popupContainer, "transform", "translate(-50%, -50%)");

      setImportantStyle(panel, "width", "min(640px, calc(100vw - 98px))");
      setImportantStyle(panel, "max-width", "calc(100vw - 98px)");
      setImportantStyle(panel, "max-height", "calc(100dvh - 98px)");
      setImportantStyle(panel, "overflow-x", "hidden");
      setImportantStyle(panel, "overflow-y", "auto");
      setImportantStyle(panel, "overscroll-behavior-y", "contain");

      if (imageElement) {
        setImportantStyle(imageElement, "background-position", "center bottom");
      }

      return true;
    }

    setImportantStyle(panel, "position", "fixed");
    setImportantStyle(panel, "top", mobileLayout.top + "px");
    setImportantStyle(panel, "right", "auto");
    setImportantStyle(panel, "bottom", "auto");
    setImportantStyle(panel, "left", "50%");
    setImportantStyle(panel, "width", "min(640px, calc(100vw - 24px))");
    setImportantStyle(panel, "max-width", "calc(100vw - 24px)");
    setImportantStyle(panel, "max-height", Math.max(1, mobileLayout.height - mobileLayout.top - mobileLayout.bottom) + "px");
    setImportantStyle(panel, "height", "auto");
    setImportantStyle(panel, "min-width", "0");
    setImportantStyle(panel, "display", "flex");
    setImportantStyle(panel, "flex-direction", "column");
    setImportantStyle(panel, "transform-origin", "center top");
    setImportantStyle(panel, "transform", getFormsPopupViewportTransform());
    setImportantStyle(panel, "z-index", "2147483646");
    setImportantStyle(panel, "overflow-x", "clip");
    setImportantStyle(panel, "overflow-y", "clip");

    if (imageElement) {
      setImportantStyle(imageElement, "background-position", "center bottom");
      // The photograph gives up space before the form, rather than creating a scroll area.
      setImportantStyle(imageElement, "height", "320px");
      setImportantStyle(imageElement, "min-height", "0");
      setImportantStyle(imageElement, "flex", "0 1 320px");
      setImportantStyle(imageElement, "width", "100%");
    }

    if (contentElement) {
      setImportantStyle(contentElement, "flex", "0 0 auto");
      setImportantStyle(contentElement, "min-width", "0");
      setImportantStyle(contentElement, "padding", Math.min(24, Math.max(12, mobileLayout.height * 0.03)) + "px 20px");
      if (mobileLayout.height <= 519) {
        // Short landscape screens need less whitespace, while retaining full-size controls and consent.
        setImportantStyle(contentElement, "padding", "8px 20px");
        setImportantStyle(formElement, "gap", "6px");
        setImportantStyle(contentElement.firstElementChild, "margin", "0 0 8px");
        setImportantStyle(contentElement.lastElementChild, "margin", "6px 0 0");
        if (mobileLayout.width >= 600) {
          setImportantStyle(formElement, "display", "grid");
          setImportantStyle(formElement, "grid-template-columns", "repeat(2, minmax(0, 1fr))");
          setImportantStyle(formElement.firstElementChild, "grid-column", "1 / -1");
          setImportantStyle(formElement.querySelector("button[type='submit']"), "grid-column", "1 / -1");
        }
        if (imageElement) {
          setImportantStyle(imageElement, "height", "0");
          setImportantStyle(imageElement, "flex", "0 0 0px");
        }
      }
    }

    panel.querySelectorAll("input:not([type='hidden']), textarea, select").forEach(function (control) {
      if (!formsPopupControlStyleStates.some(function (entry) { return entry.element === control; })) {
        formsPopupControlStyleStates.push({
          element: control,
          styles: captureInlineStyleState(control, ["font-size"])
        });
      }
      // Readable fields avoid iPhone's automatic focus zoom; manual pinch zoom stays available.
      setImportantStyle(control, "font-size", Math.max(16, parseFloat(window.getComputedStyle(control).fontSize) || 16) + "px");
    });

    countryButton = panel.querySelector(".phone-country-selector button[aria-expanded]");
    phoneInput = countryButton && countryButton.closest(".phone-country-selector").parentElement.querySelector("input[type='tel']");
    if (countryButton && phoneInput) {
      if (!formsPopupControlStyleStates.some(function (entry) { return entry.element === countryButton; })) {
        formsPopupControlStyleStates.push({
          element: countryButton,
          styles: captureInlineStyleState(countryButton, ["height", "max-height"])
        });
      }
      // Match layout pixels; the panel transform scales both controls together.
      setImportantStyle(countryButton, "height", phoneInput.offsetHeight + "px");
      setImportantStyle(countryButton, "max-height", "none");
    }

    if (closeWrapper) {
      setImportantStyle(closeWrapper, "position", "absolute");
      setImportantStyle(closeWrapper, "top", "12px");
      setImportantStyle(closeWrapper, "right", "12px");
      setImportantStyle(closeWrapper, "bottom", "auto");
      setImportantStyle(closeWrapper, "left", "auto");
      setImportantStyle(closeWrapper, "z-index", "2147483646");
    }

    syncFormsPopupAncestors(panel, popupContainer);
    return true;
  }

  function restoreFormsPopupAncestors() {
    formsPopupAncestorStyleStates.forEach(function (entry) {
      restoreInlineStyleState(entry.element, entry.styles);
    });
    formsPopupAncestorStyleStates = [];
  }

  function syncFormsPopupAncestors(panel, popupContainer) {
    var outerDialog = panel.parentElement && panel.parentElement.closest("section.withImage[role='dialog']");

    if (!popupContainer || !outerDialog || outerDialog === panel) {
      restoreFormsPopupAncestors();
      return;
    }
    if (formsPopupAncestorStyleStates.length
      && (formsPopupAncestorStyleStates[0].element !== outerDialog
        || formsPopupAncestorStyleStates[1].element !== popupContainer)) {
      restoreFormsPopupAncestors();
    }
    if (!formsPopupAncestorStyleStates.length) {
      formsPopupAncestorStyleStates = [outerDialog, popupContainer].map(function (element) {
        return { element: element, styles: captureInlineStyleState(element, ["position", "height", "min-height", "padding"]) };
      });
    }
    formsPopupAncestorStyleStates.forEach(function (entry, index) {
      setImportantStyle(entry.element, "position", index === 0 ? "static" : "relative");
      setImportantStyle(entry.element, "height", "0px");
      setImportantStyle(entry.element, "min-height", "0px");
      setImportantStyle(entry.element, "padding", "0px");
    });
  }

  function releaseMenuForFormsPopup(root, panel) {
    var modals;

    if (!window.Alpine || typeof window.Alpine.store !== "function") {
      return;
    }

    modals = window.Alpine.store("modals");

    if (!modals || !modals.leftDrawer || !modals.leftDrawer.open || modals.leftDrawer.contents !== "sidebar") {
      return;
    }

    // The signup app owns its own dialog. Release the menu's focus trap first.
    modals.close("sidebar");
    window.Alpine.nextTick(function () {
      window.requestAnimationFrame(function () {
        var activeElement;
        var input;

        if (!root.isConnected || !panel.isConnected || root.getAttribute("data-current-step") !== "form" || modals.leftDrawer.open) {
          return;
        }

        activeElement = panel.getRootNode().activeElement;
        if (activeElement && panel.contains(activeElement)) {
          return;
        }

        input = panel.querySelector("input[inputmode='email'], input[autocomplete='email'], input[type='email'], input[name='email']");
        if (input && !input.disabled) {
          input.focus({ preventScroll: true });
        }
      });
    });
  }

  function isElementVisible(element) {
    if (!element) {
      return false;
    }

    return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function clearFormsTeaserPosition(root) {
    var teaserButton;

    if (!root || root.getAttribute("data-nackt-forms-teaser-positioned") !== "true") {
      return;
    }

    teaserButton = getFormsTeaserButton(root);
    restoreInlineStyleState(root, formsTeaserRootStyleState);
    restoreInlineStyleState(teaserButton, formsTeaserButtonStyleState);

    formsTeaserRootStyleState = null;
    formsTeaserButtonStyleState = null;
    root.removeAttribute("data-nackt-forms-teaser-positioned");
  }

  function syncFormsTeaserPosition(root) {
    var teaserButton;
    var topOffset;
    var dismissStyle;

    if (!root) {
      clearFormsPopupPresentation();
      clearFormsTeaserPosition(root);
      return false;
    }

    if (root.getAttribute("data-current-step") === "form") {
      clearFormsTeaserPosition(root);
      return syncFormsPopupPresentation(root);
    }

    clearFormsPopupPresentation();

    if (root.getAttribute("data-current-step") !== "tease") {
      clearFormsTeaserPosition(root);
      return false;
    }

    teaserButton = getFormsTeaserButton(root);

    if (!teaserButton || !isElementVisible(teaserButton)) {
      clearFormsTeaserPosition(root);
      return false;
    }

    if (!root.querySelector("style[data-nackt-forms-teaser-dismiss]")) {
      dismissStyle = document.createElement("style");
      dismissStyle.setAttribute("data-nackt-forms-teaser-dismiss", "");
      dismissStyle.textContent =
        "#app-embed[data-current-step='tease'] [data-testid='form-teaser'] { position: relative !important; }" +
        "#app-embed[data-current-step='tease'] [data-testid='form-teaser'] [role='button']::after { content: ''; position: absolute; inset: 0 0 0 auto; width: calc(100% / 3); cursor: pointer; }";
      root.appendChild(dismissStyle);
    }

    if (root.getAttribute("data-nackt-forms-teaser-positioned") !== "true") {
      formsTeaserRootStyleState = captureInlineStyleState(root, [
        "position",
        "top",
        "left",
        "right",
        "bottom",
        "width",
        "max-width",
        "height",
        "padding",
        "transform",
        "background-color",
        "z-index",
        "visibility",
        "opacity",
        "pointer-events"
      ]);
      formsTeaserButtonStyleState = captureInlineStyleState(teaserButton, [
        "max-width",
        "margin",
        "visibility",
        "opacity",
        "pointer-events"
      ]);
      root.setAttribute("data-nackt-forms-teaser-positioned", "true");
    }

    topOffset = Math.max(12, Math.round(getHeaderOffset() + 12));

    setImportantStyle(root, "position", "fixed");
    setImportantStyle(root, "top", topOffset + "px");
    setImportantStyle(root, "left", "1rem");
    setImportantStyle(root, "right", "auto");
    setImportantStyle(root, "bottom", "auto");
    setImportantStyle(root, "width", "auto");
    setImportantStyle(root, "max-width", "calc(100vw - 2rem)");
    setImportantStyle(root, "padding", "0");
    setImportantStyle(root, "transform", "none");
    setImportantStyle(root, "z-index", "100");
    setImportantStyle(root, "visibility", "visible");
    setImportantStyle(root, "opacity", "1");
    setImportantStyle(root, "pointer-events", "auto");
    setImportantStyle(teaserButton, "max-width", "min(22rem, calc(100vw - 2rem))");
    setImportantStyle(teaserButton, "margin", "0");
    setImportantStyle(teaserButton, "visibility", "visible");
    setImportantStyle(teaserButton, "opacity", "1");
    setImportantStyle(teaserButton, "pointer-events", "auto");

    return true;
  }

  function observeFormsTeaserRoot(root) {
    var tree;

    if (!formsTeaserRootObserver || !root) {
      return;
    }

    formsTeaserRootObserver.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-current-step", "data-position", "style", "class"]
    });

    tree = root.getRootNode();
    if (tree !== document) {
      formsTeaserRootObserver.observe(tree, { childList: true, subtree: true });
    }
  }

  function scheduleFormsTeaserSync() {
    if (formsTeaserScheduledSync !== null) {
      return;
    }

    formsTeaserScheduledSync = window.requestAnimationFrame(function () {
      var root = getFormsRoot();

      formsTeaserScheduledSync = null;
      bindFormsTeaserRootObserver(root);

      if (formsTeaserRootObserver) {
        formsTeaserRootObserver.disconnect();
      }

      try {
        syncFormsTeaserPosition(root);
      } finally {
        observeFormsTeaserRoot(root);
      }

      if (root) {
        window.clearTimeout(formsTeaserPolling);
        formsTeaserPolling = null;
        formsTeaserDiscoveryDelay = 250;
      } else if (formsTeaserPolling === null) {
        formsTeaserPolling = window.setTimeout(function () {
          formsTeaserPolling = null;
          scheduleFormsTeaserSync();
        }, formsTeaserDiscoveryDelay);
        formsTeaserDiscoveryDelay = Math.min(formsTeaserDiscoveryDelay * 2, 2000);
      }
    });
  }

  function bindFormsTeaserRootObserver(root) {
    if (!window.MutationObserver || formsTeaserObservedRoot === root) {
      return;
    }

    if (formsTeaserRootObserver) {
      formsTeaserRootObserver.disconnect();
    }

    clearFormsTeaserPosition(formsTeaserObservedRoot);
    clearFormsPopupPresentation();
    formsTeaserObservedRoot = root;
    formsTeaserRootObserver = null;

    if (!root) {
      return;
    }

    formsTeaserRootObserver = new window.MutationObserver(scheduleFormsTeaserSync);
  }

  function initializeFormsTeaserObserver() {
    if (formsTeaserDocumentObserver || !window.MutationObserver) {
      return;
    }

    formsTeaserDocumentObserver = new window.MutationObserver(function () {
      if (!formsTeaserObservedRoot || !formsTeaserObservedRoot.isConnected) {
        scheduleFormsTeaserSync();
      }
    });

    formsTeaserDocumentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    scheduleFormsTeaserSync();
    window.addEventListener("resize", scheduleFormsTeaserSync);
    window.addEventListener("orientationchange", scheduleFormsTeaserSync);
    window.addEventListener("left-drawer-will-open", scheduleFormsTeaserSync);
  }

  function isModifiedClick(event) {
    return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
  }

  var linkedSwatchMetadata = new WeakMap();

  window.nacktEditorial.resolveLinkedSwatchUrl = function (swatchLink, sourceOptionNames, option1, option2, option3) {
    var metadata = linkedSwatchMetadata.get(swatchLink);
    if (!metadata) {
      try {
        metadata = {
          baseUrl: swatchLink.getAttribute("data-linked-base-url"),
          variants: JSON.parse(swatchLink.getAttribute("data-linked-variants")),
          optionNames: JSON.parse(swatchLink.getAttribute("data-linked-option-names") || "[]")
        };
        if (!metadata.baseUrl || !Array.isArray(metadata.variants)) return swatchLink.href;
        linkedSwatchMetadata.set(swatchLink, metadata);
      } catch (error) { return swatchLink.href; }
    }
    return window.nacktEditorial.resolveLinkedProductUrl(metadata.baseUrl, metadata.variants, metadata.optionNames, sourceOptionNames, option1, option2, option3);
  };

  function resolveLinkedColourwayTargetHref(swatchLink) {
    var options = getCurrentSelectedOptions();
    return window.nacktEditorial.resolveLinkedSwatchUrl(swatchLink, getCurrentProductOptionNames(), options.option1, options.option2, options.option3);
  }

  function getCurrentVariantAvailableState(productRoot) {
    var availabilityAttribute;
    var addToCartButton;
    var addToCartText;

    if (!productRoot) {
      return null;
    }

    availabilityAttribute = productRoot.getAttribute("data-current-variant-available");

    if (availabilityAttribute === "true") {
      return true;
    }

    if (availabilityAttribute === "false") {
      return false;
    }

    addToCartButton = productRoot.querySelector(".add-to-cart");

    if (!addToCartButton) {
      return null;
    }

    addToCartText = (addToCartButton.textContent || "").toLowerCase();

    if (addToCartText.indexOf("sold out") !== -1 || addToCartButton.disabled) {
      return false;
    }

    return true;
  }

  function getCurrentVariantIdFromProductRoot(productRoot) {
    var variantInput;

    if (!productRoot) {
      return null;
    }

    variantInput = productRoot.querySelector("[data-current-variant-id-input], form.shopify-product-form input[name='id'], form.shopify-product-form select[name='id']");

    return variantInput ? variantInput.value : null;
  }

  function resetRestockRocketRefresh() {
    if (restockRocketRefreshTimer) {
      window.clearTimeout(restockRocketRefreshTimer);
      restockRocketRefreshTimer = null;
    }

    restockRocketRefreshVariantId = null;
    restockRocketRefreshAttempts = 0;
  }

  function dispatchRestockRocketVariantRefresh(productRoot, variantId) {
    var productForm;

    if (!productRoot || !variantId) {
      return;
    }

    if (
      window._RestockRocket
      && typeof window._RestockRocket.renderButtonForVariant === "function"
    ) {
      window._RestockRocket.renderButtonForVariant(variantId);
      return;
    }

    productForm = productRoot.querySelector("form.shopify-product-form");

    if (!productForm) {
      return;
    }

    productForm.querySelectorAll("[name='id']").forEach(function (variantInput) {
      if (variantInput.tagName === "SELECT") {
        Array.from(variantInput.options).forEach(function (option) {
          option.selected = option.value === String(variantId);
        });
      } else {
        variantInput.value = variantId;
      }

      variantInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function scheduleRestockRocketRefresh(productRoot) {
    var currentVariantId = getCurrentVariantIdFromProductRoot(productRoot);
    var refreshDelay;

    if (!currentVariantId) {
      return;
    }

    if (restockRocketRefreshVariantId !== currentVariantId) {
      resetRestockRocketRefresh();
      restockRocketRefreshVariantId = currentVariantId;
    }

    if (restockRocketRefreshTimer || restockRocketRefreshAttempts >= restockRocketRefreshDelays.length) {
      return;
    }

    refreshDelay = restockRocketRefreshDelays[restockRocketRefreshAttempts];
    restockRocketRefreshAttempts += 1;
    restockRocketRefreshTimer = window.setTimeout(function () {
      var latestProductRoot = getCurrentProductRoot();
      var latestVariantId = getCurrentVariantIdFromProductRoot(latestProductRoot);

      restockRocketRefreshTimer = null;

      if (
        !latestProductRoot
        || latestVariantId !== currentVariantId
        || getCurrentVariantAvailableState(latestProductRoot) === true
        || document.getElementById("restock-rocket-inline-container")
      ) {
        return;
      }

      dispatchRestockRocketVariantRefresh(latestProductRoot, latestVariantId);
      window.setTimeout(scheduleRestockRocketPlacement, 120);
    }, refreshDelay);
  }

  function syncCompactRestockButtonState(restockContainer) {
    var emailInput;
    var restockButton;
    var emailIsValid;

    if (!restockContainer) {
      return;
    }

    emailInput = restockContainer.querySelector("#form-Email");
    restockButton = restockContainer.querySelector("#form-Button");

    if (!emailInput || !restockButton) {
      return;
    }

    emailIsValid = emailInput.value.trim() !== "" && emailInput.checkValidity();
    restockButton.disabled = !emailIsValid;
    restockButton.setAttribute("aria-disabled", emailIsValid ? "false" : "true");
    restockButton.setAttribute("data-nackt-compact-validation", "true");
  }

  function initializeCompactRestockButtonValidation(restockContainer) {
    var emailInput;

    if (!restockContainer) {
      return;
    }

    emailInput = restockContainer.querySelector("#form-Email");

    if (!emailInput) {
      return;
    }

    if (!emailInput.__nacktCompactValidationBound) {
      emailInput.__nacktCompactValidationBound = true;
      ["input", "change", "blur"].forEach(function (eventName) {
        emailInput.addEventListener(eventName, function () {
          syncCompactRestockButtonState(restockContainer);
          window.requestAnimationFrame(function () {
            syncCompactRestockButtonState(restockContainer);
          });
        });
      });
    }

    syncCompactRestockButtonState(restockContainer);
  }

  function moveRestockRocketAboveCheckoutButtons() {
    if (getCurrentProductRoot()?.nacktColourwayController) return;
    var productRoot = getCurrentProductRoot();
    var restockContainer = document.getElementById("restock-rocket-inline-container");
    var addToCartContainer;
    var productForm;
    var stickyTray;
    var useCompactTray;
    var restockButton;
    var compactButtonLabel;

    if (!productRoot) {
      return;
    }

    stickyTray = productRoot.querySelector(".nackt-mobile-sticky-purchase-tray");
    useCompactTray = !!stickyTray;

    if (getCurrentVariantAvailableState(productRoot) === true) {
      if (restockContainer) {
        restockContainer.hidden = true;
        restockContainer.setAttribute("aria-hidden", "true");
        restockContainer.classList.add("nackt-restock-inline-container--hidden");
      }

      if (stickyTray) {
        stickyTray.classList.remove("nackt-mobile-sticky-purchase-tray--restock");
      }

      resetRestockRocketRefresh();
      return;
    }

    if (!restockContainer) {
      scheduleRestockRocketRefresh(productRoot);
      return;
    }

    addToCartContainer = productRoot.querySelector(".nackt-product-form__block--buy-buttons .add-to-cart-container, .nackt-product-form__block--buy_buttons .add-to-cart-container");

    if (!addToCartContainer) {
      return;
    }

    productForm = addToCartContainer.closest("form");

    if (!productForm) {
      return;
    }

    if (useCompactTray) {
      if (restockContainer.parentNode !== stickyTray || restockContainer.nextElementSibling !== addToCartContainer) {
        stickyTray.insertBefore(restockContainer, addToCartContainer);
      }

      stickyTray.classList.add("nackt-mobile-sticky-purchase-tray--restock");
      restockContainer.classList.add("nackt-restock-inline-container--compact");

      restockButton = restockContainer.querySelector("#form-Button");
      if (restockButton) {
        compactButtonLabel = stickyTray.getAttribute("data-nackt-restock-remind-label") + " \u2192";
        if (restockButton.textContent !== compactButtonLabel) {
          restockButton.textContent = compactButtonLabel;
        }
      }

      initializeCompactRestockButtonValidation(restockContainer);
    }

    restockContainer.hidden = false;
    restockContainer.removeAttribute("aria-hidden");
    restockContainer.classList.add("nackt-restock-inline-container");
    restockContainer.classList.remove("nackt-restock-inline-container--hidden");
    resetRestockRocketRefresh();
  }

  function scheduleRestockRocketPlacement() {
    if (restockRocketPlacementFrame) {
      return;
    }

    restockRocketPlacementFrame = window.requestAnimationFrame(function () {
      restockRocketPlacementFrame = null;
      moveRestockRocketAboveCheckoutButtons();
    });
  }

  function initializeRestockRocketPlacement() {
    var productRoot = getCurrentProductRoot();
    if (productRoot && productRoot.nacktColourwayController) { resetRestockRocketRefresh(); restockRocketPlacementObserver?.disconnect(); return; }
    if (restockRocketObservedProduct === productRoot && restockRocketPlacementObserver) return;
    restockRocketPlacementObserver?.disconnect();
    restockRocketPlacementObserver = null;
    restockRocketObservedProduct = productRoot;
    if (!productRoot) return;
    restockRocketPlacementObserver = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return productRoot.contains(record.target) || Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.id === "restock-rocket-inline-container" || node.querySelector("#restock-rocket-inline-container"));
        });
      })) scheduleRestockRocketPlacement();
    });
    restockRocketPlacementObserver.observe(document.documentElement, {childList:true,subtree:true});
    if (!restockRocketEventsBound) {
      document.addEventListener("variant:change", scheduleRestockRocketPlacement);
      window.addEventListener("load", scheduleRestockRocketPlacement);
      window.addEventListener("resize", scheduleRestockRocketPlacement);
      restockRocketEventsBound = true;
    }
    scheduleRestockRocketPlacement();
  }

  function configureProductLayout() {
    var root = getCurrentProductRoot();
    var needsScroll = !!root && productLayoutBreakpoint.matches;
    if (needsScroll && !desktopPdpScrollBound) window.addEventListener("scroll", scheduleDesktopPdpPinSync, {passive:true});
    if (!needsScroll && desktopPdpScrollBound) window.removeEventListener("scroll", scheduleDesktopPdpPinSync);
    desktopPdpScrollBound = needsScroll;
    if (!root) {
      desktopPdpPinResizeObserver?.disconnect();
      mobileContextualImageResizeObserver?.disconnect();
      desktopPdpPinObservedSummary = null;
      mobileContextualImageObservedElements = [];
      return;
    }
    if (!productLayoutEventsBound) {
      window.addEventListener("resize", scheduleDesktopPdpPinSync);
      window.addEventListener("resize", scheduleMobileContextualImageSync);
      window.addEventListener("orientationchange", scheduleDesktopPdpPinSync);
      window.addEventListener("orientationchange", scheduleMobileContextualImageSync);
      window.addEventListener("load", scheduleDesktopPdpPinSync);
      window.addEventListener("load", scheduleMobileContextualImageSync);
      window.visualViewport?.addEventListener("resize", scheduleMobileContextualImageSync);
      productLayoutEventsBound = true;
    }
    scheduleDesktopPdpPinSync();
    scheduleMobileContextualImageSync();
  }

  window.nacktEditorial.resolveLinkedProductUrl = function resolveLinkedProductUrl(
    baseUrl,
    variants,
    destinationOptionNames,
    sourceOptionNames,
    option1,
    option2,
    option3
  ) {
    var variantList = Array.isArray(variants) ? variants : [];
    var currentOptions = [option1 || null, option2 || null, option3 || null];
    var sourceSizeIndex = getSizeOptionIndex(sourceOptionNames);
    var destinationSizeIndex = getSizeOptionIndex(destinationOptionNames);
    var selectedSize = sourceSizeIndex >= 0 ? currentOptions[sourceSizeIndex] : null;
    var sizeMatchAvailable = null;
    var sizeMatch = null;
    var exactMatch = variantList.find(function (variant) {
      return variant.option1 === currentOptions[0]
        && variant.option2 === currentOptions[1]
        && variant.option3 === currentOptions[2]
        && variant.available;
    });
    var fallbackExactMatch = variantList.find(function (variant) {
      return variant.option1 === currentOptions[0]
        && variant.option2 === currentOptions[1]
        && variant.option3 === currentOptions[2];
    });
    var fallbackAvailable = variantList.find(function (variant) {
      return variant.available;
    });

    if (selectedSize && destinationSizeIndex >= 0) {
      sizeMatchAvailable = variantList.find(function (variant) {
        return variant["option" + (destinationSizeIndex + 1)] === selectedSize && variant.available;
      });
      sizeMatch = variantList.find(function (variant) {
        return variant["option" + (destinationSizeIndex + 1)] === selectedSize;
      });
    }

    var targetVariant = sizeMatchAvailable || sizeMatch || exactMatch || fallbackExactMatch || fallbackAvailable || variantList[0];

    if (!targetVariant || !targetVariant.id) {
      return baseUrl;
    }

    try {
      var url = new URL(baseUrl, window.location.origin);
      url.searchParams.set("variant", targetVariant.id);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return baseUrl + (baseUrl.indexOf("?") === -1 ? "?" : "&") + "variant=" + targetVariant.id;
    }
  };

  document.addEventListener("click", function (event) {
    var swatchLink = event.target.closest(".nackt-linked-colourways__swatch");
    var targetHref;
    var targetUrl;

    if (!swatchLink || event.defaultPrevented) {
      return;
    }

    if (swatchLink.closest("[data-product-root]")?.querySelector("[data-colourway-state]")) return;

    if (isModifiedClick(event) || swatchLink.target === "_blank") {
      return;
    }

    targetHref = resolveLinkedColourwayTargetHref(swatchLink);

    try {
      targetUrl = new URL(targetHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (targetUrl.pathname === getCurrentProductPath()) {
      return;
    }

    saveLinkedColourwayScroll(targetHref);
    saveLinkedColourwayMedia(targetHref);
  });

  window.addEventListener("popstate", function () {
    var currentProductRoot = getCurrentProductRoot();

    if (!currentProductRoot || currentProductRoot.querySelector("[data-colourway-state]")) {
      return;
    }

    if (window.location.pathname === getCurrentProductPath()) {
      return;
    }

    window.location.reload();
  });

  window.nacktEditorial.prepareColourwayRestock = function (widget) {
    var tray = getCurrentProductRoot()?.querySelector(".nackt-mobile-sticky-purchase-tray");
    var button = widget.querySelector("#form-Button");
    var label = tray?.getAttribute("data-nackt-restock-remind-label");
    if (button && label && button.textContent.trim() !== label + " \u2192") button.textContent = label + " \u2192";
    initializeCompactRestockButtonValidation(widget);
  };

  window.nacktEditorial.refreshColourwayPresentation = function (root) {
    resetRestockRocketRefresh();
    restockRocketPlacementObserver?.disconnect();
    configureProductLayout();
    scheduleMobileContextualImageSync();
    initializeSizeSystemPickers(root);
  };

  productLayoutBreakpoint.addEventListener("change", configureProductLayout);
  window.addEventListener("load", function () {
    initializeSizeSystemPickers(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initializeSizeSystemPickers(event.target);
    configureProductLayout();
    initializeRestockRocketPlacement();
  });

  document.addEventListener("theme:variant:change", function (event) {
    var productRoot = event.detail && event.detail.productRootEl ? event.detail.productRootEl : document;

    productRoot.querySelectorAll("[data-nackt-size-picker]").forEach(function (sizePicker) {
      updateSizePickerCurrentLabel(
        sizePicker,
        normalizeSizeSystem(sizePicker.getAttribute("data-nackt-size-system"))
          || getPreferredSizeSystem(sizePicker.getAttribute("data-nackt-size-default-system"))
      );
    });

    scheduleMobileContextualImageSync();
  });

  document.addEventListener("shopify:section:unload", function (event) {
    if (restockRocketObservedProduct && event.target.contains(restockRocketObservedProduct)) {
      restockRocketPlacementObserver?.disconnect(); restockRocketPlacementObserver = null; restockRocketObservedProduct = null;
      window.removeEventListener("scroll", scheduleDesktopPdpPinSync); desktopPdpScrollBound = false;
      desktopPdpPinResizeObserver?.disconnect(); mobileContextualImageResizeObserver?.disconnect();
    }
  });

  restoreLinkedColourwayScroll();
  initializeSizeSystemPickers(document);
  configureProductLayout();
  scheduleDesktopPdpPinSync();
  scheduleMobileContextualImageSync();
  initializeRestockRocketPlacement();
  initializeFormsTeaserObserver();
})();
